<div class="row text-left">
  <div class="col-sm-12">
    <div class="content-header">Tour</div>
    <p class="content-sub-header">Apex template tour</p>
  </div>
</div>
<!-- Apex template tour starts -->
<section id="tours">
  <div class="row text-left">
    <div class="col-xl-4 col-lg-4 col-12">
      <div class="card">
        <div class="card-header">
          <h4>User Tour</h4>
        </div>
        <div class="card-body">
          <div>
            <p>Click this button to start a demo user Tour.</p>
            <button id="btnStartTour" class="btn btn-primary" (click)="startTour()">Start Tour</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-4 col-lg-4 col-12">
      <div class="card">
        <div class="card-header">
          <h4>Define Your Steps</h4>
        </div>
        <div class="card-body">
          <div>
            <pre class="language-javascript text-left">
<code class="language-javascript">steps: [
    &#123;
        title: "Customizer",
        content: "This is the customizer",
        target: "customizer-toggle-icon",
        placement: "left"
    },
    &#123;
        ...
    }
]</code></pre>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-4 col-lg-4 col-12">
      <div class="card">
        <div class="card-header">
          <h4>Initialize Tour</h4>
        </div>
        <div class="card-body">
          <div>
            <pre class="language-javascript">
<code class="language-javascript">hopscotch.startTour(this.tourSteps());</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Apex template tour Ends -->

</section>
